import { LeagueInteraction } from "./LeagueInteraction";
import { LeagueHandler } from "../services/api/eslapi/LeagueHandler";
import { ISettingsService } from "../typings/typings";
import { Store } from "@ngrx/store";
import { RootState } from "@play/state";
import { TeamResource, LeagueService } from "ng-league";

enum MatchActionState {
    enterResult,
    confirmResult,
    waitingForConfirm,
    waitingForLeader,
    autoResult,
    abortCancel,
    confirmCancel,
    abortMove,
    confirmMove,
}

export const LeagueInteractionCtrl = [
    "$scope",
    "$filter",
    "LeagueMatchResource",
    "LegacyUrlService",
    "$timeout",
    "SharedContestantStateService",
    "SettingsService",
    "LeagueHandler",
    "LeagueService",
    "$q",
    "DialogService",
    "store",
    "TeamResource",
    (
        $scope,
        $filter,
        LeagueMatchResource,
        LegacyUrlService,
        $timeout,
        SharedContestantStateService,
        SettingsService,
        LeagueHandler: LeagueHandler,
        LeagueService: LeagueService,
        $q,
        DialogService,
        store: Store<RootState>,
        TeamResource: TeamResource
    ) => {
        $scope.leagueInter = new LeagueInteraction(
            $scope,
            $filter,
            LeagueMatchResource,
            $timeout,
            SharedContestantStateService,
            SettingsService,
            LeagueHandler,
            LeagueService,
            $q,
            DialogService,
            store
        );

        $scope.getLeagueInteraction = function() {
            return $scope.leagueInter;
        };

        $scope.getLeague = function() {
            return $scope.leagueInter.league;
        };

        /**
         * Returns the path of the current league with out legacy prefix.
         * The path always starts with a slash and ends without a trailing slash.
         */
        $scope.getLeaguePath = function() {
            let uri = $scope.leagueInter.league.getUri();
            let path = LegacyUrlService.getPathFromLegacyPath(uri);

            // strip trailing slash
            if (path.charAt(path.length - 1) === "/") {
                path = path.substr(0, path.length - 1);
            }

            return path;
        };

        $scope.getCurrentState = function() {
            return $scope.leagueInter.currentState;
        };

        $scope.getMatch = function() {
            return $scope.leagueInter.currentMatch;
        };

        $scope.getMatches = function(status) {
            if (typeof $scope.leagueInter.matches !== "undefined") {
                if ($scope.leagueInter.matches.hasOwnProperty(status)) {
                    return $scope.leagueInter.matches[status];
                }
            }

            return [];
        };

        /**
         * Get the current action state of the match
         *
         * @returns {string}
         */
        $scope.getMatchActionState = function() {
            let league = $scope.getLeague(),
                match = $scope.getMatch(),
                leagueInteraction = $scope.getLeagueInteraction(),
                result,
                hasPermission = !league.isTeamLeague() || leagueInteraction.userHasTeamPermissions();

            if (hasPermission) {
                if (match.noneConfirmed() && league.canEnterResult()) {
                    result = MatchActionState.enterResult;
                } else if (match.waitingForMeConfirm()) {
                    result = MatchActionState.confirmResult;
                } else if (match.waitingForOpponentConfirm()) {
                    result = MatchActionState.waitingForConfirm;
                }
            } else {
                result = MatchActionState.waitingForLeader;
            }

            if (!league.canEnterResult() && match.noneConfirmed()) {
                result = MatchActionState.autoResult;
            }

            switch (match.getCancelStatus()) {
                case 1:
                    result = MatchActionState.abortCancel;
                    break;
                case 2:
                    result = MatchActionState.confirmCancel;
                    break;
            }
            switch (match.getMoveStatus()) {
                case 1:
                    result = MatchActionState.abortMove;
                    break;
                case 2:
                    result = MatchActionState.confirmMove;
                    break;
            }

            return MatchActionState[result];
        };
    },
];

export const leagueInteraction = [
    "SettingsService",
    (SettingsService: ISettingsService) => {
        const obj = {
            link: function(scope, element, attrs) {
                scope.leagueInteraction = {};
                scope.templateUrls = {
                    templateInformationUrl: "league-widget/%s/information.html",
                    templateMatchUrl: "league-widget/%s/match.html",
                    templateResultUrl: "league-widget/%s/result.html",
                    templateUserActionUrl: "league-widget/%s/userAction.html",
                    templateHeaderUrl: "league-widget/%s/header.html",
                    templateChallengeTypesUrl: "league-widget/%s/challengeTypes.html",
                };
                scope.leagueId = parseInt(attrs.leagueId, 10);
                scope.gameAccountType = attrs.gameAccountType;
                scope.gameAccountDescription = attrs.gameAccountDescription;
                scope.gameAccountExample = attrs.gameAccountExample;
                scope.gameAccountHelpLink = attrs.gameAccountHelpLink;
                scope.gameAccountName = attrs.gameAccountName;
                scope.user = SettingsService.user;
            },
            restrict: "E",
        };

        // Fix for angularjs + angular AoT
        obj["templateUrl"] = "league-widget/league/base.html";

        return obj;
    },
];
